import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { DynamicActionsBrickTypeEnum } from 'src/app/components/bricks/dynamic-actions-brick/dynamic-actions-brick-configuration/dynamic-actions-brick-type-enum';
import { CallTagsSelectors } from 'src/app/store/samwin/call-tags/call-tags.selectors';
import { TagReplaceResult } from 'src/app/store/samwin/call-tags/call-tags.state';
import { DynamicActionsBrickSettingsState } from '../../../brick-settings/specific-brick-settings/dynamic-actions-brick-settings/dynamic-actions-brick-settings.state';
import { DynamicActionsBehaviorState } from './dynamic-actions-behavior.state';

export class DynamicActionsBehaviorStateSelectors {
   constructor() {}

   @Selector([DynamicActionsBehaviorState.getDynamicActionsBrickConfigurationType])
   public static getSpecificType(getDynamicActionsBrickConfigurationType: (brickInstanceId: string) => 'buttons' | 'dropdown') {
      return (brickInstanceId: string) => {
         const type = getDynamicActionsBrickConfigurationType(brickInstanceId);
         if (_.isNil(type)) {
            return DynamicActionsBrickTypeEnum.UNKNOWN;
         }
         try {
            return DynamicActionsBrickTypeEnum.valueOf(type);
         } catch {
            return DynamicActionsBrickTypeEnum.UNKNOWN;
         }
      };
   }

   @Selector([DynamicActionsBrickSettingsState.getJsonConfigurationFn, CallTagsSelectors.getReplaceAllTagsInTextForActiveOrRingingCallOrAfterCallWorkFn])
   public static getSpecificJsonConfigurationWithReplacedTagsFn(
      getJsonConfigurationFn: (brickInstanceId: string) => string,
      getReplaceAllTagsInTextForActiveOrRingingCallFn: (text: string) => TagReplaceResult
   ) {
      return (brickInstanceId: string) => {
         const jsonConfiguration = getJsonConfigurationFn(brickInstanceId);
         return getReplaceAllTagsInTextForActiveOrRingingCallFn(jsonConfiguration).text;
      };
   }
}
